module.exports = __webpack_public_path__ + "img/espace-pro.4092360.png";